import {makeStyles} from "@material-ui/core"
import {ModernTheme} from "../../../../../theme/modern/tokens"
import {COARSE, TOUCH_MIN} from "../../../../../theme/modern/touchTargets"

export default makeStyles((theme: ModernTheme) => ({
    block: {
        marginBottom: 12,
    },
    label: {
        display: "block",
        font: `600 10px/1 ${theme.modern.sans}`,
        letterSpacing: ".1em",
        textTransform: "uppercase",
        color: theme.modern.ink3,
        marginBottom: 5,
    },
    value: {
        display: "block",
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
        font: `400 13px/1.5 ${theme.modern.sans}`,
        color: theme.modern.ink,
        background: theme.modern.panel2,
        border: `1px solid ${theme.modern.line}`,
        borderRadius: 8,
        padding: "8px 10px",
        maxHeight: 160,
        overflowY: "auto",
    },
    value__empty: {
        color: theme.modern.ink3,
        fontStyle: "italic",
    },
    warn: {
        display: "flex",
        gap: "8px",
        alignItems: "flex-start",
        background: theme.modern.warnSoft,
        border: `1px solid ${theme.modern.resWarnBorder}`,
        borderRadius: 8,
        padding: "8px 10px",
        marginBottom: 12,
        font: `500 12px/1.45 ${theme.modern.sans}`,
        color: theme.modern.warn,
    },
    check: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        cursor: "pointer",
        font: `500 12.5px ${theme.modern.sans}`,
        color: theme.modern.ink2,
        marginTop: 4,

        "& input": {
            width: 15,
            height: 15,
            accentColor: theme.modern.accent,
            cursor: "pointer",
            flex: "none",

            [COARSE]: {width: 20, height: 20},
        },

        [COARSE]: {minHeight: TOUCH_MIN},
    },
}))
